import { Entry } from "@napi-rs/keyring";

/**
 * OS-native keychain wrapper (macOS Keychain, Windows Credential Manager,
 * libsecret on Linux) via `@napi-rs/keyring`.
 *
 * One credential per profile: service `whop-cli`, account = profile name.
 * `getSecret` returns `null` (rather than throwing) when the entry is missing or
 * the keychain is locked, so callers can treat "no secret" as a normal state.
 */

const SERVICE = "whop-cli";

function entry(profileName: string): Entry {
	return new Entry(SERVICE, profileName);
}

export function setSecret(profileName: string, secret: string): void {
	entry(profileName).setPassword(secret);
}

export function getSecret(profileName: string): string | null {
	try {
		return entry(profileName).getPassword();
	} catch {
		return null;
	}
}

export function deleteSecret(profileName: string): void {
	try {
		entry(profileName).deletePassword();
	} catch {
		// nothing to delete (or keychain unavailable) — treat as already gone
	}
}
